import api from 'api/api.config';

import { buildQueryParams } from 'helpers/api/build-query-params';
import type {
  SortDirection,
  FilterValue,
} from 'helpers/api/build-query-params';

import type { CollectionResponse } from 'api/market-view-api';

const getBasePath = (userId: string, clientId: string | number): string =>
  `/${userId}/clients/${clientId}/reports`;

export interface ClientReportsListParams {
  pageSize?: number;
  pageIndex?: number;
  sortBy?: SortDirection[];
  filters?: Record<string, FilterValue> | null;
}

export const getClientReportsList = async (
  userId: string,
  clientId: string | number,
  params: ClientReportsListParams = {},
): Promise<CollectionResponse> => {
  const { pageSize, pageIndex = 0, sortBy, filters } = params;

  const response = await api.get(getBasePath(userId, clientId), {
    params: buildQueryParams({
      pageSize,
      pageIndex,
      sortBy,
      filters,
      searchTerms: undefined,
      forceSearch: undefined,
    }),
  });

  const totalCount = response.headers['x-total-count'];
  const pageSizeHeader = response.headers['x-page-size'];
  const pageCount = response.headers['x-page-count'];

  const numPages = Math.ceil(
    Number.parseInt(totalCount, 10) /
      Number.parseInt(String(pageSizeHeader || pageSize || '10'), 10),
  );

  return {
    data: response.data,
    pagination: {
      page: Number.parseInt(pageCount, 10) || pageIndex,
      pageSize: Number.parseInt(pageSizeHeader, 10) || pageSize || 10,
      pageCount: numPages,
      totalRecords: Number.parseInt(totalCount, 10) || 0,
    },
  };
};
